import React from 'react';
import { FaCheckCircle, FaPalette, FaBolt, FaSyncAlt } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Custom Portraits",
      price: "Starting at ₹2,200",
      description: "Detailed pencil or digital portraits from your photos",
      features: [
        "High-resolution digital delivery",
        "Unlimited revisions",
        "Multiple size options",
        "Fast turnaround (3-5 days)"
      ],
      popular: true
    },
    {
      id: 2,
      title: "Family Portraits",
      price: "Starting at ₹5,500",
      description: "Beautiful group portraits capturing precious family moments",
      features: [
        "Up to 6 people included",
        "Custom background options",
        "Digital and print-ready files",
        "Rush delivery available"
      ],
      popular: false
    },
    {
      id: 3,
      title: "Pet Portraits",
      price: "Starting at ₹1,800",
      description: "Adorable pet portraits that capture their personality",
      features: [
        "Any pet type welcome",
        "Multiple poses available",
        "Color or black & white",
        "Perfect for gifts"
      ],
      popular: false
    },
    {
      id: 4,
      title: "Digital Illustrations",
      price: "Starting at ₹3,500",
      description: "Custom digital artwork for any purpose",
      features: [
        "Commercial use rights",
        "Multiple file formats",
        "Vector and raster options",
        "Brand integration available"
      ],
      popular: false
    },
    {
      id: 5,
      title: "Wedding Art",
      price: "Starting at ₹9,000",
      description: "Romantic artwork for your special day",
      features: [
        "Save the date designs",
        "Wedding invitations",
        "Guest book illustrations",
        "Anniversary gifts"
      ],
      popular: false
    },
    {
      id: 6,
      title: "Business Branding",
      price: "Starting at ₹6,500",
      description: "Professional artwork for your business",
      features: [
        "Logo design",
        "Social media graphics",
        "Marketing materials",
        "Brand guidelines"
      ],
      popular: false
    }
  ];

  return (
    <section id="services" className="section services">
      <div className="container">
        <div className="section-title">
          <h2>My Services</h2>
          <p>Professional art services tailored to your needs</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className={`service-card ${service.popular ? 'popular' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {service.popular && <div className="popular-badge">Most Popular</div>}
              
              <div className="service-header">
                <h3>{service.title}</h3>
                <div className="service-price">{service.price}</div>
              </div>
              
              <p className="service-description">{service.description}</p>
              
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="feature-icon"><FaCheckCircle /></span>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <button className="service-btn">
                Get Started
              </button>
            </div>
          ))}
        </div>

        <div className="services-info">
          <div className="info-card">
            <div className="info-icon"><FaPalette /></div>
            <h3>Custom Commissions</h3>
            <p>Have a specific vision? I create custom artwork tailored to your exact requirements and preferences.</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon"><FaBolt /></div>
            <h3>Fast Delivery</h3>
            <p>Most projects completed within 3-5 business days. Rush delivery available for urgent requests.</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon"><FaSyncAlt /></div>
            <h3>Unlimited Revisions</h3>
            <p>Your satisfaction is guaranteed. I offer unlimited revisions until you're completely happy with the result.</p>
          </div>
        </div>

        <div className="services-cta">
          <h3>Ready to Start Your Project?</h3>
          <p>Let's discuss your vision and create something amazing together</p>
          <div className="cta-buttons">
            <button 
              className="btn"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Get Quote
            </button>
            <button 
              className="btn btn-outline"
              onClick={() => document.getElementById('portfolio').scrollIntoView({ behavior: 'smooth' })}
            >
              View Portfolio
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
